import { Fragment } from "react";
import { ChevronRight } from "../../components/common/Icons";


export const menus = [
    {
        id: 1,
        steps: 1,
        render: <Fragment>
            <div className="flex items-center gap-2">
                <span class="number">1.</span> <span>Project preferences</span> <ChevronRight className="w-4 h-4" />
            </div>
        </Fragment>
    },
    {
        id: 2,
        steps: 3,
        render: <Fragment>
            <div className="flex items-center gap-2">
                <span class="number">2.</span> <span>Specialization and stack</span> <ChevronRight className="w-4 h-4" />
            </div>
        </Fragment>
    },
    {
        id: 3,
        steps: 6,
        render: <Fragment>
            <div className="flex items-center gap-2">
                <span class="number">3.</span> <span>Additional info</span> <ChevronRight className="w-4 h-4" />
            </div>
        </Fragment>
    },
    {
        id: 4,
        steps: 8,
        render: <Fragment>
            <div className="flex items-center gap-2">
                <span class="number">4.</span> <span>Registration</span> <ChevronRight className="w-4 h-4" />
            </div>
        </Fragment>
    },
];